/*
 * @Description: 附件管理
 * @Author: luzx
 * @Date: 2023-07-03 11:18:28
 * @LastEditors: luzx
 * @LastEditTime: 023-07-03 13:34:36
*/
import request from '@/utils/request'
export function get_detail_code(params) {
  return request({
    url: 'base/system/base/dictionary/get_detail_code',
    method: 'get',
    params
  })
}
